import { Chip, Tooltip } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import PersonIcon from '@mui/icons-material/Person'

import { normalizeStoreRelationStatus } from '../../helpers/storeRelationStatusUtils'

const VARIANT_CONFIG = {
  principal: {
    chipClassName: 'store-relations-chip--principal',
    iconClassName: 'store-relations-chip__icon--principal',
    icon: StarIcon
  },
  secondary: {
    chipClassName: 'store-relations-chip--secondary',
    iconClassName: 'store-relations-chip__icon--secondary',
    icon: PersonIcon
  }
}

const StoreRelationUserChip = ({
  label,
  status = 'active',
  variant = 'secondary'
}) => {
  const normalizedStatus = normalizeStoreRelationStatus(status)
  const variantConfig = VARIANT_CONFIG[variant] || VARIANT_CONFIG.secondary
  const Icon = variantConfig.icon

  return (
    <Tooltip title={label} arrow placement="top">
      <Chip
        className={`store-relations-chip ${variantConfig.chipClassName} store-relations-chip--${normalizedStatus}`}
        icon={
          <Icon
            className={`store-relations-chip__icon ${variantConfig.iconClassName}`}
          />
        }
        label={label}
        size="small"
      />
    </Tooltip>
  )
}

export default StoreRelationUserChip
